import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFacebook = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.99963 1.66699C14.6019 1.66699 18.3334 5.39778 18.3336 10L18.3229 10.4287C18.0999 14.832 14.4583 18.334 9.99963 18.334L9.57092 18.3232C5.16793 18.1 1.66663 14.4585 1.66663 10C1.6668 5.39789 5.39752 1.66717 9.99963 1.66699ZM9.99963 2.91699C6.08788 2.91717 2.9168 6.08824 2.91663 10C2.91663 13.6344 5.65399 16.6283 9.17932 17.0352V11.3516H6.66663V10.1016H9.17932V7.50098C9.17932 6.23539 10.2048 5.2091 11.4703 5.20898H13.3336V6.45898H11.4703C10.8951 6.4591 10.4293 6.92575 10.4293 7.50098V10.1016H12.941V11.3516H10.4293V17.0693C14.1413 16.8471 17.0836 13.7677 17.0836 10C17.0834 6.08813 13.9115 2.91699 9.99963 2.91699Z",
		fill: "white"
	})
});
export default SvgFacebook;
